import _ from 'lodash'
import sanitizeHTML from 'sanitize-html'
import HTMLReactParser from 'html-react-parser'
import humanizeString from 'humanize-string'

const humanize = str => _.capitalize(
  _.split(str, /_|-/).join(' ')
)

// HR: For the time being as I don't have time to check if adding the
// id removal to the above function messes anything up
const realHumanize = str => humanize(str).replace(' id', '')

const stripTags = str => (
  str.replace(/<\/?[^>]+(>|$)|(\s{2,})|(^\s+)|(\s+$)/g, '')
)

// Convert < to HTML entity in string
const escapeTag = (tag, string) => string.replace(tag, tag.replace('<', '&lt;'))

// Have to put in possibleString as we have no strict types and so this causes issues when non-strings are passed in
const simpleHtmlFormat = (possibleString) => {
  const str = _.toString(possibleString)
  let inputStr = str
  // Find all that: Start < not followed by / with 1+ word characters
  const result = [...str.matchAll(/<(?!:\/)\w+/g)]

  // Iterate over match & seperate valid and invalid html tags
  result.forEach((val) => {
    const tag = val[0]
    const stripped = tag.replace(/<|>/g, '')
    if (!sanitizeHTML.defaults.allowedTags.includes(stripped)) {
      inputStr = escapeTag(tag, str)
    }
  })

  return HTMLReactParser(
    sanitizeHTML(inputStr)
      .replace(/\n{3,}|\n{2}\s*\n{2}/g, '\n\n').replace(/\n/g, '<br />')
  )
}

class StringManipulator { }

StringManipulator.humanize = humanize
StringManipulator.simpleFormat = simpleHtmlFormat

export default StringManipulator
export {
  humanize,
  simpleHtmlFormat,
  realHumanize,
  stripTags,
  humanizeString
}
